import React from 'react';
import { PulseLoader } from 'react-spinners';

const ButtonLoader = () => {
  return <PulseLoader color="#ffffff" size={16} />;
};

export default ButtonLoader;
